import handler from 'api/handler'

const prefix = '/public/news'

const methods = {
    fetchNews: args => handler({ method: 'get', url: prefix + '/fetch', args }),
    updateNews: args => handler({ method: 'post', url: prefix + '/update', args }) ,
    likeNews: args => handler({ method: 'post', url: prefix + '/like', args }),
    commentOnNews: args => handler({ method: 'post', url: prefix + '/comment', args }),
    shareNews: args => handler({ method: 'post', url: prefix + '/share', args })
}

export default methods